module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "text-truncate",
    attrs: {
      "items": _vm.storeNames,
      "item-text": "name",
      "label": "Store"
    },
    on: {
      "change": _vm.handleStoreChange
    },
    model: {
      value: (_vm.selectedStore),
      callback: function($$v) {
        _vm.selectedStore = $$v
      },
      expression: "selectedStore"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-menu', {
    ref: "startDtMenu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.startDt,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.startDt = $event
      },
      "update:return-value": function($event) {
        _vm.startDt = $event
      }
    },
    model: {
      value: (_vm.startDtMenu),
      callback: function($$v) {
        _vm.startDtMenu = $$v
      },
      expression: "startDtMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "value": _vm.formattedStartDt,
      "label": "Start Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function () {
        _vm.$refs.startDtMenu.save(_vm.startDt);
        _vm.getDataFromApi();
      }
    },
    model: {
      value: (_vm.startDt),
      callback: function($$v) {
        _vm.startDt = $$v
      },
      expression: "startDt"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-menu', {
    ref: "endDtMenu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "return-value": _vm.endDt,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.endDt = $event
      },
      "update:return-value": function($event) {
        _vm.endDt = $event
      }
    },
    model: {
      value: (_vm.endDtMenu),
      callback: function($$v) {
        _vm.endDtMenu = $$v
      },
      expression: "endDtMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "value": _vm.formattedEndDt,
      "label": "End Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function () {
        _vm.$refs.endDtMenu.save(_vm.endDt);
        _vm.getDataFromApi();
      }
    },
    model: {
      value: (_vm.endDt),
      callback: function($$v) {
        _vm.endDt = $$v
      },
      expression: "endDt"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm1": "",
      "mr-3": "",
      "pt-2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": ""
    },
    on: {
      "click": _vm.exportExcelFile
    }
  }, [_vm._v("DOWNLOAD")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "body-2 font-weight-regular accent--text"
  }, [_vm._v("POS Transactions\n          ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "lg12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredResults,
      "pagination": _vm.pagination,
      "total-items": _vm.totalResults,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(ref) {
        var header = ref.header;

        return [_c('span', {
          staticClass: "body-2 font-weight-regular accent--text",
          domProps: {
            "textContent": _vm._s(header.text)
          }
        })]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.settlementDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.posId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.transactionNarration))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.card))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.approvalCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.transactionDate))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(parseFloat(props.item.amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(parseFloat(props.item.commission).toLocaleString(
          undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(parseFloat(props.item.cashback).toLocaleString(
          undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(parseFloat(props.item.cashback_COMM).toLocaleString(
          undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(parseFloat(props.item.settlementAmount).toLocaleString(
          undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )) + "\n                ")])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v("\n                  Kindly Select Start Date\n                  and End Date to download the transactions statement\n                ")]), _vm._v(" "), _c('Loader', {
    attrs: {
      "visible": _vm.loadingSpin
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "round": ""
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eea4903c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/transaction/viewposstatementstoday.vue
// module id = 1074
// module chunks = 2